import { mapState } from 'vuex'
import { _getTranslation } from '@/services/api/translations'

export default {
	computed: {
		...mapState(['availableLanguages'])
	},
	methods: {
		loadTranslations (language) {
			const lang = this.availableLanguages.some(item => item.code === language) ? language : 'en'
			_getTranslation(lang)
				.then(response => {
					this.$store.dispatch('setTranslations', response).then(() => {
						this.languageLoaded = true
					})
				})
		}
	}
}
